<template>
    <div :class="[ 'loader', { 'is-active': isActive } ]">
        <svg xmlns="http://www.w3.org/2000/svg" width="34.833" height="34.833" viewBox="0 0 34.833 34.833"
             :class="{ 'loader-animated' : animated}">
            <g transform="translate(33.333 1.5) rotate(90)">
                <circle class="a" cx="15.917" cy="15.917" r="15.917"/>
                <path class="b" d="M31.833,16.214A15.918,15.918,0,1,1,15.918,0"/>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "Loader",
        data() {
            return {
                animated: true
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/mixin';
    @import 'src/assets/scss/_variables/color';

    .loader {
        // position: absolute;
        font-size: 3rem;
        opacity: 0;
        //@include transition();
        //@include position-center-both-axis();

        &-animated {
            @include animation(0, 1s, infinite, spinner);
            @include animation-timing-function(linear);
        }

        &.is-active {
            opacity: 1;
        }

        .a, .b {
            fill: none;
            stroke-miterlimit: 10;
            stroke-width: 3px;
        }

        .a {
            stroke: #ebebec;
        }

        .b {
            stroke: $color-primary;
        }
    }
</style>
